<template>
  <router-link :to="{ name: 'DashboardProfile' }" title="Modifier mon profil" tag="div" class="menu-icon">
    <div>
      <img src="/static/images/icons/User.svg"/>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'header-menu-profile',
}
</script>
